/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from '../../Constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAllUsers: (params) => {
    return axios.get(API_ENDPOINTS.GET_USERS, {
      headers: { isAuthRequired: true, 'Content-Type': 'application/json' },
      params: { ...params },
    })
  },
}
